export const ChevronRightIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M3.98186 0.807625C3.79368 0.622869 3.79368 0.323322 3.98186 0.138566C4.17004 -0.0461888 4.47513 -0.0461888 4.66331 0.138566L12.5 7.83274L4.32258 15.8614C4.13441 16.0462 3.82931 16.0462 3.64113 15.8614C3.45296 15.6767 3.45296 15.3771 3.64113 15.1924L11.1371 7.83273L3.98186 0.807625Z"
                fill="currentColor"
            />
        </svg>
    );
};
